export default "71856:210:P, 123063:643:P, 71741:855:P, CONFIG.4084879, CONFIG.3966127\n";